<template>
  <div class="ac-component-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>XL = ωL | XC = 1/ωC$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 动态波形对比区 -->
      <div class="canvas-item chart">
         <div class="label">电压(白)与电流(蓝)波形相位</div>
         <svg width="100%" height="150" viewBox="0 0 400 150">
            <line x1="0" y1="75" x2="400" y2="75" stroke="rgba(255,255,255,0.1)" />
            <!-- 电压波 -->
            <path :d="voltagePath" fill="none" stroke="#fff" stroke-width="1.5" stroke-dasharray="4,2" />
            <!-- 电流波 -->
            <path :d="currentPath" fill="none" stroke="#00d2ff" stroke-width="2.5" />
         </svg>
      </div>

      <!-- 元件示意图 -->
      <div class="canvas-item schematic">
         <div class="comp-box">
            <div class="comp-icon" v-if="mode === 'L'">🌀 <span>电感 L</span></div>
            <div class="comp-icon" v-if="mode === 'C'">|| <span>电容 C</span></div>
            <div class="comp-icon" v-if="mode === 'R'">/\/ <span>电阻 R</span></div>
         </div>
         <div class="phase-text">{{ phaseDescription }}</div>
      </div>

      <!-- 控制面板 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="mode-select">
               <el-radio-group v-model="mode" size="mini">
                  <el-radio-button label="R">纯电阻</el-radio-button>
                  <el-radio-button label="L">纯电感</el-radio-button>
                  <el-radio-button label="C">纯电容</el-radio-button>
               </el-radio-group>
            </div>
            <div class="row">
               <div class="col">
                  <label>交流电频率 f (Hz)</label>
                  <el-slider v-model="freq" :min="10" :max="100" size="mini"></el-slider>
               </div>
            </div>
         </div>

         <div class="physics-rule-card">
            <p><strong>总结：</strong> 
               <span v-if="mode==='R'">电阻：电压电流<strong>同相</strong>。</span>
               <span v-if="mode==='L'">电感：电流<strong>滞后</strong>电压 90° (通直阻交)。</span>
               <span v-if="mode==='C'">电容：电流<strong>超前</strong>电压 90° (通交隔直)。</span>
            </p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ACComponentViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mode: 'R',
      freq: 50,
      time: 0,
      running: true
    }
  },
  computed: {
    omega() { return 2 * Math.PI * this.freq * 0.05; },
    phaseShift() {
       if (this.mode === 'L') return -Math.PI/2;
       if (this.mode === 'C') return Math.PI/2;
       return 0;
    },
    phaseDescription() {
       if (this.mode === 'L') return "电流滞后于电压 90°";
       if (this.mode === 'C') return "电流超前于电压 90°";
       return "电压与电流相位相同";
    },
    voltagePath() {
       let d = "M 0 75";
       for(let x=0; x<=400; x+=2) {
          const t = this.time - (400-x)*0.01;
          const y = 75 - 50 * Math.sin(this.omega * t);
          d += ` L ${x} ${y}`;
       }
       return d;
    },
    currentPath() {
       let d = "M 0 75";
       for(let x=0; x<=400; x+=2) {
          const t = this.time - (400-x)*0.01;
          const y = 75 - 40 * Math.sin(this.omega * t + this.phaseShift);
          d += ` L ${x} ${y}`;
       }
       return d;
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { this.running = false; },
  methods: {
    animate() {
       if (!this.running) return;
       this.time += 0.05;
       requestAnimationFrame(this.animate);
    }
  }
}
</script>

<style scoped lang="scss">
.ac-component-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #00d2ff; background: rgba(0,210,255,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; padding: 15px; border: 1px solid rgba(255,255,255,0.05);
   &.schematic { flex: 0.4; display: flex; justify-content: center; align-items: center; gap: 30px; }
   .label { font-size: 0.65rem; color: #888; margin-bottom: 10px; }
   .comp-icon { color: #ffd700; font-size: 1.5rem; display: flex; flex-direction: column; align-items: center; span { font-size: 0.8rem; margin-top: 5px; color: #888; } }
   .phase-text { color: #2ed573; font-size: 1rem; font-family: monospace; }
}
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 12px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .mode-select { margin-bottom: 15px; text-align: center; } .row { label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } }
.physics-rule-card { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
